<template>
  <div class="box" :style="{ 'padding-bottom': footerHeight, 'min-height': minHeight}">
    <Immersion :title="$t('FoodC_C_Coupon_package_aeUS')" />
    <template v-if="couponInfo.buttonStatus == 1 || couponInfo.buttonStatus == 2">
      <Banner :benefitName="benefits.benefitName" :image="benefits.image" />
      <!-- 权益概括文案 -->
      <div class="equity-summary">
        <div>
          {{ $t("FoodC_C_Unlimited_store_Ujro") }},{{
            $t("FoodC_C_Up_to_boqc", { money: benefits.displayPriceSplit.display })
          }}
        </div>
      </div>
      <!-- 券包列表 -->
      <CouponList
        :status="couponInfo.buttonStatus"
        :couponBatchList="benefits.couponBatchList"
        v-if="benefits && benefits.couponBatchList"
      />
      <div class="benefit-desc" v-if="benefits.benefitDesc">{{ benefits.benefitDesc }}</div>
      <CouponRule :ruleDesc="benefits.ruleDesc" />
      <Footer
        v-show="isBuy"
        ref="newCouponFooter"
        :status="couponInfo.buttonStatus"
        :refreshTs="benefits.refreshTs"
        :priceText="benefits.priceSplit.display"
        :productId="benefits.saleID"
        :price="benefits.price"
        :bubbleContent="benefits.bubbleContent"
        @get-task-init="initData"
        @coupon-package-pay="couponPackagePay"
      />
    </template>
    <template v-else-if="couponInfo.buttonStatus == 9">
      <EmptyState />
    </template>
  </div>
</template>
<script>
import { getBenefitDetail } from '@/api/couponCenter/index.js'
import { get, isEmpty } from 'lodash-es'

import Immersion from '@/components/immersion/index.vue'
import Banner from './components/banner.vue'
import CouponList from './components/couponList/index.vue'
import CouponRule from './components/couponRule.vue'
import Footer from './components/footer/index.vue'
import EmptyState from './components/emptyState/index.vue'
import { couponPackageCommonSw, couponPackagePaySw } from '@/page/newCouponsCenter/track'

export default {
  components: {
    Immersion,
    Banner,
    CouponList,
    CouponRule,
    Footer,
    EmptyState
  },
  data () {
    return {
      couponInfo: {},
      benefits: {},
      footerHeight: 0,
      minHeight: 0
    }
  },
  computed: {
    isBuy () {
      return +this.$route.query.isBuy === 1
    }
  },
  watch: {
    'couponInfo.buttonStatus': function (newV, oldV) {
      if (newV === 1 || newV === 2) {
        this.$nextTick(() => {
          this.setBoxPaddingBottom()
        })
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      const params = {}
      const {saleID, bindID, purchaseLimitBindId} = this.$route.query
      if (!isEmpty(saleID)) {
        params.saleID = saleID * 1
      }
      if (!isEmpty(bindID)) {
        params.bindID = bindID * 1
      }
      if (!isEmpty(purchaseLimitBindId)) {
        params.bindID = purchaseLimitBindId * 1
      }
      const res = await getBenefitDetail({
        ...params
      })
      if (res && !res.errno) {
        this.couponInfo = get(res, 'data', {})
        this.benefits = this.couponInfo
      } else {
        if (res.data && res.data.length === 0) {
          this.$set(this.couponInfo, 'buttonStatus', 9)
        }
      }
      this.couponPackageCommon()
    },
    couponPackageCommon () {
      const batchList = get(this.benefits, 'couponBatchList', []).map(item => item.couponBatchId).join()
      couponPackageCommonSw({
        scene: this.isBuy ? 1 : 2, // 1 独立购买 2 随单买
        buy_status: this.couponInfo.buttonStatus, // 1 可购买 2 已购买 9 其他
        activity_id: this.couponInfo.activityID, // 活动id
        benefit_id: this.benefits.benefitID, // 券包id
        batch_list: batchList, // 批次列表
        amount: this.benefits.price// 券包金额
      })
    },
    couponPackagePay () {
      const batchList = get(this.benefits, 'couponBatchList', []).map(item => item.couponBatchId).join()
      couponPackagePaySw({
        scene: this.isBuy ? 1 : 2, // 1 独立购买 2 随单买
        buy_status: this.couponInfo.buttonStatus, // 1 可购买 2 已购买 9 其他
        activity_id: this.couponInfo.activityID, // 活动id
        benefit_id: this.benefits.benefitID, // 券包id
        batch_list: batchList, // 批次列表
        amount: this.benefits.price// 券包金额
      })
    },
    setBoxPaddingBottom () {
      this.footerHeight =
        get(this.$refs.newCouponFooter, '$el.offsetHeight', 0) + 40 + 'px'
      this.minHeight = `calc(100% - ${this.footerHeight})`
    }
  }
}
</script>
<style lang="scss" scoped>
.equity-summary {
  margin: 40px;
  font-family: "Aspira Medium";
  font-size: 48px;
  color: #000000;
  line-height: 56px;
  font-weight: 500;
}
.benefit-desc {
  margin: 0 40px 32px;
  font-family: "Aspira Light";
  font-size: 28px;
  line-height: 34px;
  font-weight: 200;
  word-break:break-all;
  white-space:normal
}
.box {
  background: #fff;
  min-height: auto;
}
</style>
